module.exports = __webpack_public_path__ + "static/media/pencil_gray.a04688ce.svg";